import { useEffect, useRef, useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { GLOBAL_UI } from '@/config/missionContent';

export default function AudioManager({ enabled, started, onToggle }) {
  const audioRef = useRef(null);
  const [volume, setVolume] = useState(0.3);
  const [showSlider, setShowSlider] = useState(false);

  useEffect(() => {
    if (!started) return;
    if (!audioRef.current) {
      const audio = new Audio('/audio/bg-ambient.mp3');
      audio.loop = true;
      audio.volume = volume;
      audioRef.current = audio;
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [started]);

  useEffect(() => {
    if (!audioRef.current) return;
    if (enabled) {
      audioRef.current.play().catch(() => {});
    } else {
      audioRef.current.pause();
    }
  }, [enabled, started]);

  useEffect(() => {
    if (audioRef.current) audioRef.current.volume = volume;
  }, [volume]);

  useEffect(() => {
    return () => {
      if (audioRef.current) {
        audioRef.current.pause();
        audioRef.current.src = '';
        audioRef.current = null;
      }
    };
  }, []);

  return (
    <div
      className="fixed top-4 left-4 z-50 flex items-center gap-2"
      onMouseEnter={() => setShowSlider(true)}
      onMouseLeave={() => setShowSlider(false)}
    >
      <button
        onClick={onToggle}
        className="w-10 h-10 rounded-full bg-black/60 border border-white/10 flex items-center justify-center text-gray-400 hover:text-white hover:border-white/30 transition-all"
        data-testid="audio-toggle"
        title={enabled ? GLOBAL_UI.audio.muteLabel : GLOBAL_UI.audio.enableLabel}
      >
        {enabled ? <Volume2 size={18} /> : <VolumeX size={18} />}
      </button>

      <div
        className={`flex items-center h-10 px-3 rounded-full bg-black/60 border border-white/10 transition-all duration-300 ${
          showSlider ? 'opacity-100 w-28' : 'opacity-0 w-0 overflow-hidden px-0'
        }`}
      >
        <input
          type="range"
          min="0"
          max="1"
          step="0.01"
          value={volume}
          onChange={(e) => setVolume(parseFloat(e.target.value))}
          className="w-full h-1 accent-white cursor-pointer appearance-none bg-white/20 rounded-full [&::-webkit-slider-thumb]:appearance-none [&::-webkit-slider-thumb]:w-3 [&::-webkit-slider-thumb]:h-3 [&::-webkit-slider-thumb]:rounded-full [&::-webkit-slider-thumb]:bg-white"
        />
      </div>
    </div>
  );
}
